<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="employeeId"
      :itemNames="['name_1','name_2','name_3','name_4','name_5']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :showResetButton="true"
      @reset="resetEvent"
    >
      <a-form-item slot="name_1" label="真实姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.employeeName" :maxLength="20" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobile" :maxLength="11" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="企业" v-bind="searchItemLayout">
        <SelectEnterpriseModal
          :inputValue='queryParams.enterpriseId'
          :inputText='enterpriseName'
          @selectEnterpriseEvent='selectEnterprise'
        />
      </a-form-item>
      <a-form-item slot="name_4" label="状态" v-bind="searchItemLayout">
        <a-select v-model="queryParams.status" style="width: 100%" allowClear placeholder="请选择">
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="2">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="name_5" label="过期状态" v-bind="searchItemLayout">
        <a-select v-model="queryParams.expiredStatus" style="width: 100%" allowClear placeholder="请选择">
          <a-select-option :value="1">有效</a-select-option>
          <a-select-option :value="2">已过期</a-select-option>
        </a-select>
      </a-form-item>
      <span slot="enterpriseName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.enterpriseName }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.enterpriseName }}
          </div>
        </a-tooltip>
      </span>
      <span slot="employeeName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.employeeName }} ( {{ rowItem.record.mobile }} )
          </template>
          <div class="pro_title">
            {{ rowItem.record.employeeName }} ( {{ rowItem.record.mobile }} )
          </div>
        </a-tooltip>
      </span>
      <span slot="employeeNickname" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.employeeNickname }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.employeeNickname }}
          </div>
        </a-tooltip>
      </span>
      <div slot="operation" style="margin: 0 0 20px 20px;">
        <a-button style="margin-right: 20px" type="primary" @click="editEvent('add')">添加员工</a-button>
        <a-button type="primary" @click="uploadEvent">批量上传</a-button>
      </div>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent('edit',rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm :title="'是否要'+(rowItem.record.status === 1 ? '禁用' : '启用')+'当前员工'"
                      @confirm="updateStatus(rowItem.record)">
          <a>{{ rowItem.record.status === 1 ? '禁用' : '启用' }}</a>
        </a-popconfirm>
      </span>
    </search-page-view>

    <a-modal
      title='员工信息'
      okText="保存"
      :visible='modalVisible'
      :confirmLoading='submitLoading'
      width="480px"
      @ok="submitEvent"
      @cancel="cancelEvent"
    >
      <a-form-model
        :model="ruleForm"
        ref="ruleForm"
        :rules="tabRule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="企业名称" prop="enterpriseId">
          <a-select
            v-model="ruleForm.enterpriseId"
            allowClear
            showSearch
            placeholder="请选择"
            style="width: 100%"
            :disabled="isEdit"
            :filterOption='filterOption'
            @change="selectEnterpriseEvent"
          >
            <a-select-option v-for="(item,index) in enterpriseList" :key="index" :value="item.enterpriseId">
              {{ item.enterpriseName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="昵称" prop="employeeNickname">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.employeeNickname"
            :maxLength="20"
          />
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="mobile">
          <a-input
            placeholder="请输入"
            v-model.number="ruleForm.mobile"
            :maxLength="11"
          />
        </a-form-model-item>
        <a-form-model-item label="企业邮箱" prop="enterpriseEmployeeEmail">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.enterpriseEmployeeEmail"
            :maxLength="50"
          />
        </a-form-model-item>
        <a-form-model-item label="真实姓名" prop="employeeName">
          <a-input
            placeholder="请输入"
            v-model="ruleForm.employeeName"
            :maxLength="20"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="ruleForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="2">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--批量导入账号-->
    <a-modal
      title="批量上传"
      :visible="downloadFlowing"
      @cancel="downloadFlowing = false"
      :width="600"
      :footer="null"
    >
      <a-upload-dragger
        name="file"
        :action="uploadUrl"
        listType="text"
        :file-list='fileList'
        accept=".xls,.xlsx"
        @change="handleChange"
        :before-upload="handleBefore"
        :remove="handleRemove"
        :headers='headers'
      >
        <p class="ant-upload-drag-icon" style="margin-bottom:10px;">
          <a-icon type="inbox"/>
        </p>
        <p class="ant-upload-text">将文件拖到此处, 或点击选择文件</p>
      </a-upload-dragger>
      <div style="display: flex;justify-content: space-between;margin: 10px 20px 0 0;">
        <span>文件不能超过10M 最多上传1个  格式：xls、xlsx</span>
        <span>
          <span>点击下载名单模板</span>
          <a style="margin-left: 10px" @click.stop="downloadFile">下载</a>
        </span>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'
import SelectEnterpriseModal from '@/views/service/serviceProvider/welfareMall/SelectEnterpriseModal'
import Vue from 'vue'
import formMixins from '@/utils/mixins/formMixins'
import downLoadHelper from '@/utils/helper/downLoadHelper'

export default {
  name: 'WelfareMallStaffList',
  mixins: [WelfareMallMixins, formMixins],
  components: {
    SelectEnterpriseModal
  },
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      modalVisible: false,
      submitLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      ruleForm: {
        status: 1
      },
      tabRule: {
        enterpriseId: [
          { required: true, message: '请选择企业名称', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ],
        enterpriseEmployeeEmail: [
          { required: true, message: '请输入企业邮箱', trigger: ['blur', 'change'] },
          {
            pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
            message: '邮箱格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: ['blur', 'change'] }
        ]
      },
      enterpriseList: [],
      enterpriseName: '',
      isEdit: false, // 是否编辑
      downloadFlowing: false,
      uploadUrl: `${this.getAppConfig().serviceUrl}welfare/importEmployees/${this.getPlatformConfig().platformId}/${this.$store.getters.userInfo.merchantId}`,
      fileList: [],
      headers: {
        token: this.$store.getters.token
      }
    }
  },
  created() {
    // 企业管理点击员工管理
    if (Vue.ls.get('enterpriseId')) {
      this.$set(this.queryParams, 'enterpriseId', Vue.ls.get('enterpriseId'))
      Vue.ls.remove('enterpriseId')
    }
    if (Vue.ls.get('enterpriseName')) {
      this.enterpriseName = Vue.ls.get('enterpriseName')
      Vue.ls.remove('enterpriseName')
    }
  },
  methods: {
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      params.mobile = params.mobile || undefined
      return this.getHttpServices().getServerApiService().post('welfare/getEmployeeList', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'employeeId'
        },
        {
          title: '所属企业',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          width: '200px'
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          scopedSlots: { customRender: 'employeeName' },
          width: '200px'
        },
        {
          title: '昵称',
          dataIndex: 'employeeNickname',
          scopedSlots: { customRender: 'employeeNickname' },
          width: '120px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '过期时间',
          dataIndex: 'expiredTime'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '过期状态',
          dataIndex: 'expiredStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetEvent() {
      this.queryParams = {}
      this.enterpriseName = ''
      setTimeout(() => {
        this.$refs.pageList.refresh(true)
      }, 200)
    },
    async editEvent(type, record) {
      if (type === 'add') {
        this.enterpriseList = await this.getEnterpriseList(false)
        this.isEdit = false
        this.ruleForm = {
          status: 1,
          enterpriseId: this.queryParams.enterpriseId || undefined
        }
      } else {
        this.enterpriseList = await this.getEnterpriseList(true)
        this.isEdit = true
        this.ruleForm = await this.getEmployeeDetail(record)
      }
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    getEnterpriseList(isAll) { // isAll 是否查询全部
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('welfare/getEnterpriseList', {
          limitDto: {
            pageNum: 1,
            pageSize: 10000
          },
          merchantId: this.merchantId,
          platformId: this.platformId,
          status: isAll ? undefined : 1
        }).then(res => {
          resolve(res.data)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    getEmployeeDetail(record) {
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('welfare/employeeDetail', {
          employeeId: record.employeeId,
          enterpriseId: record.enterpriseId,
          merchantId: this.merchantId,
          platformId: this.platformId
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    selectEnterpriseEvent() {

    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('welfare/saveEmployee', {
          ...this.ruleForm,
          merchantId: this.merchantId,
          platformId: this.platformId
        }).then(res => {
          this.$message.success('保存成功')
          this.cancelEvent()
          if (this.ruleForm.employeeId) {
            this.$refs.pageList.refresh()
          } else {
            this.$refs.pageList.refresh(true)
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    selectEnterprise(info) { // 选择企业
      this.$set(this.queryParams, 'enterpriseId', info.value)
      this.enterpriseName = info.text
    },
    updateStatus(record) { // 启用/禁用
      let tips = record.status === 1 ? '禁用成功' : '启用成功'
      this.getHttpServices().getServerApiService().post('welfare/updateEmployeeStatus', {
        employeeId: record.employeeId,
        enterpriseId: record.enterpriseId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        status: record.status === 1 ? 2 : 1
      }).then(res => {
        this.$message.success(tips)
        this.$refs.pageList.refresh()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    uploadEvent() {
      this.fileList = []
      this.downloadFlowing = true
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.response) {
          if (file.response.status === 1) {
            file.url = file.response.url
            this.$message.success(file.response.msg)
            this.downloadFlowing = false
            this.$refs.pageList.refresh(true)
          } else if (file.response.status === -1) {
            this.$message.error(file.response.msg)
          }
        }
        return file
      })
      this.fileList = fileList
    },
    handleBefore(file) {
      return this.handleBeforeUploadExcelFile(file)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 下载模板
    downloadFile() {
      let url = `${this.getAppConfig().serviceUrl}/welfare/downloadEmployeeExcel`
      downLoadHelper.downloadImage('名单模板.xlsx', url)
    }
  }
}
</script>

<style lang="less" scoped>
.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
